<template>
<router-link class="nav-link dropdown-toggle" :to="{name: 'EventChat', params: {eventSlug: eventSlug}}">
	<div class="help-icon icon-toggle">
		<i class="material-icons">forum</i>
	</div>
	<div class="label ml-2">{{ $t('Chats') }}</div>
</router-link>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'MessageNotifications',
	components: {
	},
	data() {
		return {};
	},
	methods: {
		...mapActions({
		}),
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		eventSlug() {
			return this.$route.params.eventSlug;
		},
	},
	created() {
	},
};
</script>

<style lang="scss" scoped>
</style>
